// const baseUrl = "https://localhost:60707/api/"; // Dev
// const baseUrl = "https://jll-am-aas-tmglobaltracker-dev.azurewebsites.net/api/"; // Test Prod
const baseUrl =
  window.jllConfig && window.jllConfig.api_url
    ? window.jllConfig.api_url
    : process.env.REACT_APP_API_URL;

const cdnUrl = "/cdn/";

// const cdnUrl = "https://globaltmtrackerdatadev.blob.core.windows.net/cdn/";

export default {
  baseUrl,
  cdnUrl,
  page: `${baseUrl}Pages`,
  client: `${baseUrl}Clients`,
  leaseEvent: `${baseUrl}LeaseEvents`,
  lease: `${baseUrl}Leases`,
  property: `${baseUrl}Properties`,
  reference: `${baseUrl}References`,
  transaction: `${baseUrl}Transactions`,
  user: `${baseUrl}Users`,
  auth: `${baseUrl}Auth`,
  settings: `${baseUrl}Settings`,
  activeDirectoryUsers: `${baseUrl}ActiveDirectoryUsers`,
  pipelines: `${baseUrl}Pipelines`,
  upload: `${baseUrl}Upload`,
  usageInsights: `${baseUrl}UserInsights`,
  notifications: `${baseUrl}Notifications`,
  cache: `${baseUrl}Cache`,
  userSettings: `${baseUrl}UserSettings`,
};
